export function setSubscriptionData(userId) {
  localStorage.setItem('subscriptionData', userId);
}
export function getSubscriptionData() {
  return localStorage.getItem('subscriptionData');
}
export function deleteSubscriptionData() {
  localStorage.removeItem('subscriptionData');
}